import { commonErr } from "../components/common/errors";

export default function InsRed(ins = {
	err: commonErr.INNIT,
	errIns: commonErr.INIT,
}, action) {
	switch (action.type) {

		case "GET_TNDS_PRICE_PENDING": {
			return {
					...ins,
				err: commonErr.LOADING
			}
		}
		
		case "GET_TNDS_PRICE_FULFILLED": {
			const data = action.payload.data.data;
			const err = action.payload.data.error;
			if (data) {
	
				return {
					...ins,
					err: commonErr.SUCCESS,
					price: data.price,
					discountsTNDS: data.discounts
				}
			}
		}

		case "GET_TNDS_PRICE_REJECTED": {
            return {
                ...ins,
                err: commonErr.FAIL
            }
        }

		case "GET_INS_PRICE_PENDING": { 
			return { 
				...ins, 
				errIns: commonErr.LOADING
			}
		}

		case "GET_INS_PRICE_FULFILLED": { 
			const data = action.payload.data.data;
			const err = action.payload.data.error;
		
			if (data) { 
				return { 
					...ins,
					errIns: commonErr.SUCCESS,
					discountsIns: data.discounts,
					priceMIC: data.priceMIC,
					pricePJICO: data.pricePJICO
				}
			}
		}
		case "GET_INS_PRICE_FULFILLED_REJECTED": {
            return {
                ...ins,
                errIns: commonErr.FAIL
            }
        }

		default:
			return ins;
	}
}